import { createSiteInABoxActions, siteInABoxReducer } from "@repo/redux";
import { apiHandler } from "../../lib/apiHandler";

const actions = createSiteInABoxActions(apiHandler);

export { siteInABoxReducer };
export const fetchSiteInABoxItems = actions.fetchSiteInABoxItems;
export const fetchSiteInABoxItem = actions.fetchSiteInABoxItem;
export const addSiteInABoxItem = actions.addSiteInABoxItem;
export const fetchSiteInABoxOrgDefaults = actions.fetchSiteInABoxOrgDefaults;
export const editSiteInABoxItem = actions.editSiteInABoxItem;
export const patchSiteInABoxItem = actions.patchSiteInABoxItem;
export const deleteSiteInABoxItem = actions.deleteSiteInABoxItem;
export const getSiteInABoxSowPdf = actions.getSiteInABoxSowPdf;
export const authoriseSiteInABox = actions.authoriseSiteInABox;
export const sendEmail = actions.sendEmail;
export const setSiteInABoxPagination = actions.setSiteInABoxPagination;
export const setSiteInABoxFilters = actions.setSiteInABoxFilters;
export const clearSiteInABoxError = actions.clearSiteInABoxError;
